import {Customer} from './customer';
import {Mobile} from './mobile';
import {Broadband} from './broadband';

export class Order {
    draft = true;
    order_id: number = null;
    customer = new Customer();
    mobiles = new Array<Mobile>();
    broadband = new Broadband();
    agreements = {
        privacy_policy: true,
        commercial_communications: true
    };
}
